module.exports = __webpack_public_path__ + "static/media/Participant Information Statement - TAL.431bda93.txt";